/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import React, { useState } from 'react'
import Heading from '../Typography/Heading/Heading'

const CustomTab = ({ tabTitles, ...props }) => {
  const [selected, selectedTab] = useState(0)

  return (
    <Tabs style={{ textAlign: 'left' }}>
      <TabList>
        {props.renderItems.map((item, index) => {
          return (
            <Tab
              key={index}
              onClick={() => selectedTab(index)}
              style={{
                position: 'static',
                border: 'none',
                borderBottom: selected === index ? '3px solid black' : 'none',
                outline: 'none',
                boxShadow: 'none',
              }}
            >
              <Heading
                as="h6"
                sx={{
                  fontWeight:
                    selected === index ? selected === index && 900 : 'normal',
                }}
              >
                {item.tabTitle}
              </Heading>
            </Tab>
          )
        })}
      </TabList>
      {props.renderItems.map((item, index) => {
        return <TabPanel key={index}>{item.component}</TabPanel>
      })}
    </Tabs>
  )
}

export default CustomTab
